import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import parseServerError from 'api/helpers/parseServerError';
import styles from './Form.scss';
import Spinner from './Spinner';

function Form(props) {
  const handleSubmit = e => {
    e.preventDefault();
    props.onSubmit(e);
  };

  const {
    processing,
    error,
    classes,
    className,
    children,
    ...restProps
  } = props;

  const errors = (error && parseServerError(error)) || {};

  const handleFieldChange = fieldKey => e => {
    const { onFieldChange } = props;
    onFieldChange(fieldKey, e);
  };

  const renderFormField = (field, index) => {
    if (!field) {
      return field;
    }

    const { fieldValues } = props;

    const newProps = {
      key: index,
    };

    if (field.props.type === 'submit') {
      newProps.onClick = handleSubmit;
      newProps.disabled = field.props.disabled || props.processing;
    }

    if (field.props.fieldKey) {
      const { fieldKey } = field.props;

      newProps.value = fieldValues[fieldKey];
      newProps.error = errors[fieldKey] || field.props.error;
      newProps.onChange = handleFieldChange(fieldKey);
    }

    return React.cloneElement(field, newProps);
  };

  return (
    <form
      {...restProps}
      className={classnames(
        styles.form,
        { [classes.root]: classes.root },
        { [className]: className },
      )}
      onSubmit={handleSubmit}
    >
      {processing && (
        <Spinner
          overlay
          className={classnames(styles.loader, {
            [classes.loader]: classes.loader,
          })}
        />
      )}
      {Array.isArray(children)
        ? children.map(renderFormField)
        : [children].map(renderFormField)}
      <span className={styles.error}>{errors.common}</span>
    </form>
  );
}

Form.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  processing: PropTypes.bool,
  error: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  fieldValues: PropTypes.object,
};

Form.defaultProps = {
  processing: false,
  className: null,
  error: PropTypes.string,
  classes: {
    root: null,
    overlay: null,
    loader: null,
  },
  fieldValues: {},
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/controls/Form.jsx